import { jsx as a, jsxs as c } from "react/jsx-runtime";
const g = ({
  measurementUnit: e,
  setIsShowProductBadge: d,
  unitMultiplier: r
}) => e === "un" ? null : r < 1 ? (d(!0), /* @__PURE__ */ a("div", { className: "product-card-badge", children: /* @__PURE__ */ c("p", { className: "product-card-badge-kg", children: [
  r * 1e3,
  "g"
] }) })) : (r >= 1 && d(!0), /* @__PURE__ */ a("div", { className: "product-card-badge", children: /* @__PURE__ */ c("p", { className: "product-card-badge-kg", children: [
  r,
  "kg"
] }) }));
export {
  g as ProductCardBadgeKg
};
